var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M3.111 22q-.472 0-.791-.32a1.08 1.08 0 0 1-.32-.791v-2.695a2.2 2.2 0 0 1 .639-1.555l14.028-14q.333-.306.736-.472Q17.807 2 18.25 2q.444 0 .861.167.417.165.722.5l1.528 1.555q.333.306.486.722.151.417.153.834 0 .444-.153.848a2.1 2.1 0 0 1-.486.735l-14 14q-.306.306-.709.472a2.2 2.2 0 0 1-.846.167zM18.222 7.333l1.556-1.555-1.556-1.556-1.555 1.556z"
  })));
};
export default SvgPencil;